<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="公告标题" prop="noticeTitle">
                <a-input v-model="queryParam.noticeTitle" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="副标题" prop="subtitle">
                <a-input v-model="queryParam.subtitle" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="单据状态" prop="status">
               <a-select placeholder="请选择" v-model="queryParam.status" allowClear>
                  <a-select-option  :value="1">
                    已关闭
                  </a-select-option>
                  <a-select-option  :value="2">
                    已发布
                  </a-select-option>
                  <a-select-option  :value="0">
                    已保存
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting 
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
     
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :height=500
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="id" slot-scope="text, record">
          <span>{{record.id}}</span>
        </span>

        <span slot="status" slot-scope="text, record">
           <span v-if="record.status==1">已关闭</span>
            <span v-if="record.status==2">已发布</span>
             <span v-if="record.status==0">已保存</span>
        </span>


         <span slot="isRead" slot-scope="text, record">
           <span v-if="record.isRead==1">已读</span>
            <span v-if="record.isRead==0">未读</span>
        </span>


        <span slot="operation" slot-scope="text, record">
          <a @click="promotionManagerDetail(record)">
            查看详情
          </a>

          <!-- <a @click="handleDelete(record)" v-hasPermi="['system:notice:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
       <saveView ref="saveRef"></saveView>

    </a-card>
  </page-header-wrapper>

  
</template>

<script>
import saveView from './save.vue'
import moment from 'moment'
import { pageNotice, delNotice,readNotice } from '@/api/system/notice'

import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'


export default {
  name: 'noticeNew',
  components: {
    saveView
  },
  mixins: [tableMixin],
  data () {
    return {
      wNum:0,
        options:[
        {
            value:1,
            label:'已保存'
        },{
            value:2,
            label:'已发布'
        }
    ],
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickName: null,
        id: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '公告编号',
          dataIndex: 'id',
          align: 'center',
          scopedSlots: {customRender: 'id'},
        },
        {
          title: '公告标题',
          dataIndex: 'noticeTitle',
          align: 'center'
        },
        {
          title: '副标题',
          dataIndex: 'subtitle',
          align: 'center'
        },
        {
          title: '单据状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: {customRender: 'status'},
        },

         {
          title: '是否已读',
          dataIndex: 'isRead',
          align: 'center',
          scopedSlots: {customRender: 'isRead'},
        },

        

        {
          title: '创建者',
          dataIndex: 'relationCount',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {

    
  },  

  methods: {
    moment,

    setNum(item){
      return item.num/item.max*100
    },
    promotionManagerDetail(record) {
      const noticeId = record ? record.id : ids
      this.$router.push({
        name: 'NewForm',
        params:
        {
          id: noticeId,
          formTitle: '公告编辑'
        }
      })


     

    
      
    },
    /** 查询用户-用户搜索记录列表 */
    getList () {
      this.loading = true
     pageNotice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        this.wNum = 80
      })
    },


    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const noticeIds = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + noticeIds + '的数据',
        onOk() {
          return delNotice(noticeIds)
            .then(() => {
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          that.selectedRows = []
          that.selectedRowKeys = []
          that.multiple = true
          that.single = true
         }
      })
    },




    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id: null,
        userName: null,
        createTime: null,
        num: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
<style scoped>


</style>